const keyCodes = {
  arrowUp: 38,
  arrowDown: 40,
  esc: 27,
  enter: 13,
  numPad0: 96,
  numPad9: 105,
  keyA: 65,
  keyZ: 91,
  keyNAcute: 192,
};

class KeyboardHelper {
  static getCharFromEventListener(code) {
    if (code > 47 && code < 58) {
      return String.fromCharCode(code);
    }
    if (code >= keyCodes.numPad0 && code <= keyCodes.numPad9) {
      return String.fromCharCode(code - 48);
    }
    if (code >= keyCodes.keyA && code <= keyCodes.keyZ) {
      return String.fromCharCode(code);
    } else if (code === keyCodes.keyNAcute) {
      return 'Ñ';
    }
    return null;
  }
}

export { KeyboardHelper, keyCodes };



// WEBPACK FOOTER //
// ./src/helpers/KeyboardHelper.js